import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import FJAIAudioHistory from '../view/FJAIAudioHistory.jsx';
import FJActionAIAudioGenerator from '../../../../redux/action/FJActionAIAudioGenerator.js';
import FJSelectAll from '../../../../common/components/FJSelectAll/FJSelectAll.jsx';
import { setSliceSelectListAction } from '../../../../redux/slices/FJSliceCommon.js';
import FJActionCommon from '../../../../redux/action/FJActionCommon.js';
import { useEffect, useCallback, useMemo } from 'react';
import FJAudioPlayManager from '../../../../store/FJAudioPlayManager.js';
import FJRequirementsUtil from '../../../../util/FJRequirementsUtil.js';
import FJKeymap from '../../../../util/FJKeymap.js';

const FJAIAudioHistoryContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const historyList = useSelector(state => state.common.historyList);
    const selectList = useSelector(state => state.common.selectList);
    const batchDownloadLoading = useSelector(state => state.common.batchDownloadLoading);
    const isMultipleMode = useSelector(state => state.AIAudioGenerator.isMultipleMode);
    const appType = useSelector(state => state.common.appType);
    const historyTabIndex = useSelector(state => state.AIAudioGenerator.historyTabIndex);

    const useHistoryList = useMemo(() => {
        return FJRequirementsUtil.getAudioHistoryList(historyList, historyTabIndex);
    }, [historyList, historyTabIndex]);

    const onHistoryTabChange = index => {
        dispatch(FJActionAIAudioGenerator.setHistoryTabIndexAction(index));
        setSliceSelectList([]);
        clearSelected();
    };

    const setIsMultipleMode = bool => {
        dispatch(FJActionAIAudioGenerator.setIsMultipleModeAction(bool));
        FJAudioPlayManager.pauseAll();
    };

    const clearSelected = () => {
        setIsMultipleMode(false);
    };

    const setSliceSelectList = value => {
        dispatch(setSliceSelectListAction(value));
    };

    const multiDownload = (ids, source, callback) => {
        dispatch(FJActionCommon.multiDownloadAction(ids, source, callback));
    };
    const multiDelete = ids => {
        dispatch(FJActionCommon.multiDeleteAction(ids));
    };

    const _keyDown = useCallback(
        e => {
            if (e.code === 'Escape') {
                if (FJKeymap.getScope() === 'default') {
                    setSliceSelectList([]);
                    setIsMultipleMode(false);
                }
            }
        },
        [setSliceSelectList],
    );
    useEffect(() => {
        window.addEventListener('keydown', _keyDown);
        return () => {
            window.removeEventListener('keydown', _keyDown);
        };
        //TODO 业务需要此依赖
    }, [_keyDown, isMultipleMode]);

    const _onAddToMediaLibrary = () => {
        const ids = historyList.filter(item => selectList.includes(item.id)).map(item => item.id);
        dispatch(FJActionAIAudioGenerator.addToMediaLibraryAction(ids));
    };

    return (
        <>
            <FJAIAudioHistory
                historyList={useHistoryList}
                historyTabIndex={historyTabIndex}
                onHistoryTabChange={onHistoryTabChange}
            />
            <FJSelectAll
                appType={appType}
                list={useHistoryList}
                selectList={selectList}
                setSelectList={setSliceSelectList}
                multiDownload={multiDownload}
                multiDelete={multiDelete}
                batchDownloadLoading={batchDownloadLoading}
                isMultipleMode={isMultipleMode}
                clearSelected={clearSelected}
                isShowAddToMediaButton={window.isEditPage}
                onAddToMediaLibrary={_onAddToMediaLibrary}
            />
        </>
    );
};
export default FJAIAudioHistoryContainer;
